import * as React from 'react';
import type { SVGProps } from 'react';

export const SvgPlanningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path fill="currentColor"
          d="M29 8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v7h-2V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v12h-2V5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v10H3v12a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V17h2v5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-5h2v12a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V17h4zM7 26H5v-9h2zm8-5h-2v-4h2zm2-6V4h2v11zm10 0h-2V9h2z" />
  </svg>
);
